<form id="container" class="m-4" (ngSubmit)="save()">
  <h5><strong>{{ "DEVICE_NAME" | translate }}</strong></h5>
  <p>{{ "SERIAL_NUMBER" | translate }}: {{ data.deviceId }}</p>

  <div class="form-group">
    <input type="text" class="form-control" name="deviceName" cdkFocusInitial
      placeholder="{{ 'NAME' | translate }}" [(ngModel)]="name">
  </div>

  <button type="submit" class="btn btn-primary">
    {{ "SAVE" | translate }}
  </button>

  <button type="button" class="btn secondaryBtnWhiteBg ml-2" (click)="cancel()">
    {{ "CANCEL" | translate }}
  </button>
</form>
